import gql from 'graphql-tag'

export const SEND_PW_RECOVERY_TOKEN = gql`
  mutation SendToken($email: String!) {
    sendPasswordRecoveryToken(email: $email)
  }
`

export const RECOVER_PASSWORD = gql`
  mutation RecoverPassword($token: String!, $newPassword: String!) {
    recoverPassword(inputToken: $token, newPassword: $newPassword)
  }
`

export const GET_SIGNED_URL = gql`
  query GetSignedUrl($path: String!) {
    getSignedUrl(path: $path) {
      download
      upload
    }
  }
`

export const SET_INVITE_FORM_STYLES = gql`
  mutation SetInviteFormStyles($eventId: ID!, $input: InviteFormStyles!) {
    setInviteFormStyles(eventId: $eventId, input: $input)
  }
`

export const GET_PURCHASE_SIGNATURE = gql`
  query GetPurchaseSignature($purchase: String!, $eventId: ID!) {
    getPurchaseSignature(purchase: $purchase, eventId: $eventId)
  }
`

export const GET_WS_PURCHASE_SIGNATURE = gql`
  query GetWSPayPurchaseSignature($shoppingCartId: String!, $amount: String!) {
    getWSPayPurchaseSignature(shoppingCartId: $shoppingCartId, amount: $amount)
  }
`

export const GET_KEKS_QRCODE = gql`
  query GetKeksQR($orderId: ID!) {
    getKeksQR(orderId: $orderId) {
      url
      qrCode
    }
  }
`
